import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { Button, Text } from 'react-orange-ui';

import Title from '../../Title/Title';
import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

class LetterConfirm extends Component {
  handleClick = () => {
    const { quitApp } = this.props;

    TagService.sendAction('endLetter');
    quitApp();
  };

  render() {
    return (
      <Row>
        <Col sm={9} xs={12}>
          <Title id="confirmation-letter-title" label={WordingService.getWording('title', 'letterWillBeSent')} icon="tick" color="green" size={32} />
          <Text id="confirmation-letter-message">
            { WordingService.getWording('caption', 'receiveLetterSoon') }
          </Text>
          <br />
          <Button id="end-letter-button" type="fill" onClick={this.handleClick}>
            { WordingService.getWording('button', 'end') }
          </Button>
        </Col>
      </Row>
    );
  }
}

LetterConfirm.propTypes = {
  /** Action to quit the app */
  quitApp: PropTypes.func.isRequired,
};

export default LetterConfirm;
